import UXCPLayout from './UXCPLayout';

export default UXCPLayout;
